<div class="app-bookmarks-dialog">
  <div class="header">
    <h3>Select days & time</h3>
  </div>

  <div class="content">
    <div class="weekdays">
      <label for="input-{{weekday}}" class="weekday" *ngFor="let weekday of weekdays">
        <input type="checkbox" id="input-{{weekday}}" [checked]="selectedWeekdays.includes(weekday)" (change)="onDayChange(weekday)" />
        <span>{{ weekday.slice(0,1) }}</span>
      </label>
    </div>

    <div style="margin: 1.5rem 0; display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
      <mat-checkbox [checked]="isOpen24Hours" (change)="isOpen24Hours = !isOpen24Hours">Open 24 hours on all days</mat-checkbox>
      <mat-checkbox [checked]="isClosed" (change)="isClosed = !isClosed">Closed</mat-checkbox>
    </div>

    @if (!isClosed && !isOpen24Hours) {
      <div class="time-slots">
        <div class="time-slot" *ngFor="let hour of hours">
          <mat-form-field class="open" appearance="outline">
            <mat-label>Open time</mat-label>
            <input matInput type="time" [value]="hour.open" (change)="updateValue(hour, 'open', $event)">
          </mat-form-field>
          <mat-form-field class="close" appearance="outline">
            <mat-label>Close time</mat-label>
            <input matInput type="time" [value]="hour.close" (change)="updateValue(hour, 'close', $event)">
          </mat-form-field>
          <button mat-icon-button (click)="removeHours(hours.indexOf(hour))">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div style="margin-top:8px;" (click)="addHours()">
        <button mat-button>Add hours</button>
      </div>
    }

    <div class="action-buttons">
      <button mat-button type="button" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
